interface PropTypes {
    width?: number;
    height?: number;
}

const VisaIcon = ({ width = 10, height = 12 }: PropTypes) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 37 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_96_9013)">
                <path
                    d="M23.8385 0.0144501C21.2398 0.0144501 18.9175 1.33639 18.9175 3.77877C18.9175 6.57971 23.0362 6.77315 23.0362 8.18027C23.0362 8.77274 22.3444 9.30312 21.1627 9.30312C19.4858 9.30312 18.2325 8.56204 18.2325 8.56204L17.6962 11.0267C17.6962 11.0267 19.14 11.6527 21.0569 11.6527C23.8981 11.6527 26.1338 10.2658 26.1338 7.7817C26.1338 4.82199 21.998 4.63426 21.998 3.32825C21.998 2.86407 22.5659 2.35555 23.7441 2.35555C25.0735 2.35555 26.1581 2.89452 26.1581 2.89452L26.683 0.514124C26.683 0.514124 25.5028 0.0144501 23.8385 0.0144501ZM0.0629406 0.19412L0 0.553423C0 0.553423 1.09329 0.749776 2.07796 1.14151C3.34578 1.59067 3.43613 1.85217 3.64964 2.66433L5.97639 11.4674H9.09551L13.9007 0.19412H10.7888L7.70114 7.85886L6.44123 1.36185C6.32568 0.618287 5.74039 0.19412 5.02397 0.19412H0.0629406ZM15.152 0.19412L12.7108 11.4674H15.6783L18.1109 0.194084H15.152V0.19412ZM31.7027 0.19412C30.9871 0.19412 30.608 0.570106 30.3298 1.22712L25.9822 11.4674H29.0941L29.6962 9.76062H33.4874L33.8536 11.4674H36.5994L34.2039 0.19412H31.7027ZM32.1074 3.2398L33.0298 7.47007H30.5586L32.1074 3.2398Z"
                    fill="#1434CB"
                />
            </g>
            <defs>
                <clipPath id="clip0_96_9013">
                    <rect width="36.5994" height="11.6667" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default VisaIcon;
